import { Route } from 'vue-router';
import { mobileUtil } from '@panda/tool';
import { DEVICE } from '@/define/Adapter';

const queryGeek = () => (mobileUtil.isGeekApp() ? { needlogin: true, portrait: true } : {});
const QUERY = queryGeek();

export default [
  {
    path: '/trade',
    name: 'Trade',
    component: () => import(/* webpackChunkName: "trade" */ '../views/trade/Index.vue'),
    redirect: { name: 'Trade.Pay' },
    meta: {
      title: '交易中心',
    },
    children: [
      {
        path: '/trade/pay/:id',
        name: 'Trade.Pay',
        component: () => import(/* webpackChunkName: "trade.pay" */ '../views/trade/PayIndex.vue'),
        meta: {
          adapterRules: [{ device: DEVICE.Mobile }, { device: DEVICE.PC }],
          query: QUERY,
        },
        children: [
          {
            path: '/trade/pay/:id/mobile',
            name: `Trade.Pay.${DEVICE.Mobile}`,
            component: () => import(/* webpackChunkName: "trade.pay.mobile" */ '../views/trade/PayMobile.vue'),
            props: (route: Route) => ({
              id: Number(route.params.id),
            }),
            meta: {
              title: '订单确认',
              needLogin: true,
              query: QUERY,
            },
          },
          {
            path: '/trade/pay/:id/pc',
            name: `Trade.Pay.${DEVICE.PC}`,
            component: () => import(/* webpackChunkName: "trade.pay.pc" */ '../views/trade/PayPC.vue'),
            props: (route: Route) => ({
              id: Number(route.params.id),
            }),
            meta: {
              title: '订单确认',
              needLogin: true,
              query: QUERY,
            },
          },
        ],
      },
      {
        path: '/trade/success/:id',
        name: 'Trade.Success',
        component: () => import(/* webpackChunkName: "trade.success" */ '../views/trade/SuccessIndex.vue'),
        meta: {
          adapterRules: [{ device: DEVICE.Mobile }, { device: DEVICE.PC }],
          query: QUERY,
        },
        children: [
          {
            path: '/trade/success/:id/mobile',
            name: `Trade.Success.${DEVICE.Mobile}`,
            component: () => import(/* webpackChunkName: "trade.success.mobile" */ '../views/trade/SuccessMobile.vue'),
            props: (route: Route) => ({
              id: Number(route.params.id),
            }),
            meta: {
              title: '交易成功',
              needLogin: true,
              query: QUERY,
            },
          },
          {
            path: '/trade/success/:id/pc',
            name: `Trade.Success.${DEVICE.PC}`,
            component: () => import(/* webpackChunkName: "trade.success.pc" */ '../views/trade/SuccessPC.vue'),
            props: (route: Route) => ({
              id: Number(route.params.id),
            }),
            meta: {
              title: '交易成功',
              needLogin: true,
              query: QUERY,
            },
          },
        ],
      },
      {
        path: '/trade/teacher/:id',
        name: 'Trade.Teacher',
        component: () => import(/* webpackChunkName: "trade.teacher" */ '../views/trade/TeacherIndex.vue'),
        meta: {
          adapterRules: [{ device: DEVICE.Mobile }, { device: DEVICE.PC }],
          query: QUERY,
        },
        children: [
          {
            path: '/trade/teacher/:id/mobile',
            name: `Trade.Teacher.${DEVICE.Mobile}`,
            component: () => import(/* webpackChunkName: "trade.teacher.mobile" */ '../views/trade/TeacherMobile.vue'),
            props: (route: Route) => ({
              id: Number(route.params.id),
            }),
            meta: {
              title: '添加老师',
              needLogin: false,
              query: QUERY,
            },
          },
          {
            path: '/trade/teacher/:id/pc',
            name: `Trade.Teacher.${DEVICE.PC}`,
            component: () => import(/* webpackChunkName: "trade.teacher.pc" */ '../views/trade/TeacherPC.vue'),
            props: (route: Route) => ({
              id: Number(route.params.id),
            }),
            meta: {
              title: '添加老师',
              needLogin: false,
              query: QUERY,
            },
          },
        ],
      },
      {
        path: '/trade/address',
        name: 'Trade.Address',
        component: () => import(/* webpackChunkName: "trade.address" */ '../views/trade/AddressIndex.vue'),
        meta: {
          adapterRules: [{ device: DEVICE.Mobile }, { device: DEVICE.PC }],
          query: QUERY,
        },
        children: [
          {
            path: '/trade/address/mobile',
            name: `Trade.Address.${DEVICE.Mobile}`,
            component: () => import(/* webpackChunkName: "trade.address.mobile" */ '../views/trade/AddressMobile.vue'),
            meta: {
              title: '收货地址',
              needLogin: true,
              query: QUERY,
            },
          },
          {
            path: '/trade/address/pc',
            name: `Trade.Address.${DEVICE.PC}`,
            component: () => import(/* webpackChunkName: "trade.address.pc" */ '../views/trade/AddressPC.vue'),
            meta: {
              title: '收货地址',
              needLogin: true,
              query: QUERY,
            },
          },
        ],

      },
      {
        path: '/trade/my',
        name: 'Trade.MyOrder',
        component: () => import(/* webpackChunkName: "trade.my.order" */ '../views/trade/MyOrderIndex.vue'),
        meta: {
          adapterRules: [{ device: DEVICE.Mobile }, { device: DEVICE.PC }],
          query: QUERY,
        },
        children: [
          {
            path: '/trade/my/mobile',
            name: `Trade.MyOrder.${DEVICE.Mobile}`,
            component: () => import(/* webpackChunkName: "trade.my.order.mobile" */ '../views/trade/MyOrderMobile.vue'),
            meta: {
              title: '我的订单',
              needLogin: true,
              query: QUERY,
            },
          },
          {
            path: '/trade/my/pc',
            name: `Trade.MyOrder.${DEVICE.PC}`,
            component: () => import(/* webpackChunkName: "trade.my.order.pc" */ '../views/trade/MyOrderPC.vue'),
            meta: {
              title: '我的订单',
              needLogin: true,
              query: QUERY,
            },
          },
        ],
      },
      {
        path: '/trade/detail/:id',
        name: 'Trade.OrderDetail',
        component: () => import(/* webpackChunkName: "trade.OrderDetail" */ '../views/trade/OrderDetailIndex.vue'),
        meta: {
          adapterRules: [{ device: DEVICE.Mobile }, { device: DEVICE.PC }],
          query: QUERY,
        },
        props: (route: Route) => ({
          showpay: (route.query || {}).showpay || '',
        }),
        children: [
          {
            path: '/trade/detail/:id/mobile',
            name: `Trade.OrderDetail.${DEVICE.Mobile}`,
            component: () => import(/* webpackChunkName: "trade.order.detail.mobile" */ '../views/trade/OrderDetailMobile.vue'),
            meta: {
              title: '订单详情',
              needLogin: true,
              query: QUERY,
            },
            props: (route: Route) => ({
              id: Number(route.params.id),
              showpay: (route.query || {}).showpay || '',
            }),
          },
          {
            path: '/trade/detail/:id/pc',
            name: `Trade.OrderDetail.${DEVICE.PC}`,
            component: () => import(/* webpackChunkName: "trade.order.detail.pc" */ '../views/trade/OrderDetailPC.vue'),
            meta: {
              title: '订单详情',
              needLogin: true,
              query: QUERY,
            },
            props: (route: Route) => ({
              id: Number(route.params.id),
            }),
          },
        ],
      },
      {
        path: '/trade/coupon/my',
        name: 'Trade.MyCoupon',
        component: () => import(/* webpackChunkName: "trade.my.coupon" */ '../views/trade/MyCouponIndex.vue'),
        meta: {
          adapterRules: [{ device: DEVICE.Mobile }, { device: DEVICE.PC }],
          query: QUERY,
        },
        children: [
          {
            path: '/trade/coupon/my/mobile',
            name: `Trade.MyCoupon.${DEVICE.Mobile}`,
            component: () => import(/* webpackChunkName: "trade.my.coupon.mobile" */ '../views/trade/MyCouponMobile.vue'),
            meta: {
              title: '我的优惠券',
              needLogin: true,
              query: QUERY,
            },
          },
          {
            path: '/trade/coupon/my/pc',
            name: `Trade.MyCoupon.${DEVICE.PC}`,
            component: () => import(/* webpackChunkName: "trade.my.coupon.pc" */ '../views/trade/MyCouponPC.vue'),
            meta: {
              title: '我的优惠券',
              needLogin: true,
              query: QUERY,
            },
          },
        ],
      },
      {
        path: '/trade/coupon/:id',
        name: 'Trade.CouponDetail',
        component: () => import(/* webpackChunkName: "trade.coupon.detail" */ '../views/trade/CouponDetailIndex.vue'),
        meta: {
          adapterRules: [{ device: DEVICE.Mobile }, { device: DEVICE.PC }],
          query: QUERY,
        },
        children: [
          {
            path: '/trade/coupon/:id/mobile',
            name: `Trade.CouponDetail.${DEVICE.Mobile}`,
            component: () => import(/* webpackChunkName: "trade.coupon.detail.mobile" */ '../views/trade/CouponDetailMobile.vue'),
            meta: {
              title: '优惠券',
              needLogin: true,
              query: QUERY,
            },
            props: (route: Route) => ({
              id: Number(route.params.id),
            }),
          },
          {
            path: '/trade/coupon/:id/pc',
            name: `Trade.CouponDetail.${DEVICE.PC}`,
            component: () => import(/* webpackChunkName: "trade.coupon.detail.pc" */ '../views/trade/CouponDetailPC.vue'),
            meta: {
              title: '优惠券',
              needLogin: true,
              query: QUERY,
            },
            props: (route: Route) => ({
              id: Number(route.params.id),
            }),
          },
        ],
      },
      {
        path: '/trade/exchange',
        name: 'Trade.Exchange',
        component: () => import(/* webpackChunkName: "trade.exchange" */ '../views/trade/ExchangeIndex.vue'),
        meta: {
          adapterRules: [{ device: DEVICE.Mobile }, { device: DEVICE.PC }],
          query: QUERY,
        },
        children: [
          {
            path: '/trade/exchange/mobile',
            name: `Trade.Exchange.${DEVICE.Mobile}`,
            component: () => import(/* webpackChunkName: "trade.exchange.mobile" */ '../views/trade/ExchangeMobile.vue'),
            meta: {
              title: '兑换',
              needLogin: true,
              query: QUERY,
            },
          },
          {
            path: '/trade/exchange/pc',
            name: `Trade.Exchange.${DEVICE.PC}`,
            component: () => import(/* webpackChunkName: "trade.exchange.pc" */ '../views/trade/ExchangePC.vue'),
            meta: {
              title: '兑换',
              needLogin: true,
              query: QUERY,
            },
          },
        ],
      },
      {
        path: '/trade/couponAnchor/:id',
        name: 'Trade.CouponAnchorDetail',
        component: () => import(/* webpackChunkName: "trade.coupon.anchor" */ '../views/trade/CouponAnchor.vue'),
        props: (route: Route) => ({
          id: Number(route.params.id),
        }),
      },
    ],
  },
];
